
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ExportButton"
})
export default class ExportButton extends Vue {
  @Prop(String) apiUrl: string;  // "claims/exportxls"
  @Prop(Object) filter: any;
  async exportData() {
    try {
      const response: any = await (this.$root as any)._post(this.apiUrl, {
        ...this.filter
      });
      let result = await (this.$root as any)._getFile(response.path);
      let fileName = response.path.split("/").slice(-1);
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
      /*window.open(response.path);*/
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo exportar, intente más tarde.",
        "error"
      );
    }
  }
}
